import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import * as css from './CategorySelector.css';
import * as sharedCss from '../SubscriptionTypeStep/SubscriptionTypeStep.css';
import SelectItem from '../../../../../../component/selectItem/SelectItem';
import {calendar, star} from '../../../../../../assets/symbols/symbols/Symbols.css';
import {useFormikContext} from 'formik';
import useShow from '../../../../../../hooks/useShow';
import AddCategory from './AddCategory/AddCategory';
import MobilePopup from '../../../../../../component/newPopup/mobilePopup/MobilePopup';
import getSpecialTranslation from '../../../../../../functions/getSpecialTranslation';
import {categoryIconList} from '../../../../../../constants/categoryIcons';
import {SubscriptionFormValues} from '../../createSubscriptionForm.types';
import TooltipAbsolute from '../../../../../../component/tooltip/tooltipAbsolute/TooltipAbsolute';
import { getCategories } from '../../../../../../redux/categories/categoriesActions';

interface CategorySelectorProps {
    onCategorySelect: (catId: number) => void;
}

function CategorySelector({onCategorySelect}: CategorySelectorProps) {
    const {t} = useTranslation('subscriptions');
    const {t: tLayout} = useTranslation('layout');
    const {values, errors, touched} = useFormikContext<SubscriptionFormValues>();
    const {getCategoriesXHR, eventCategories: categoriesData} = useSelector((state: any) => state.categories);
    const addCategoryShow = useShow();
    const categoryError = touched.category && errors.category;

    const categories = useMemo(() => {
        if (!categoriesData?.length) {
            if(!getCategoriesXHR) {
                getCategories().then();
            }
            return [];
        }
        return categoriesData.map((c: any) => ({
            key: c.catId.toString(),
            text: getSpecialTranslation(`category${c.catId}`, tLayout) || c.title,
            icon: categoryIconList[c.catId] || 'packageImg'
        }));
    }, [categoriesData, tLayout]);

    return (
        <css.categorySection>
            <css.categoryLabel>
                <sharedCss.inputIcon $icon={calendar} />
                {t('category')}
                {categoryError && (
                    <TooltipAbsolute show={true} text={Array.isArray(categoryError) ? categoryError[0] : categoryError} dataTitleIcon={undefined} icon={star} />
                )}
            </css.categoryLabel>
            <css.categoriesWrapper>
                {categories.map((cat: any, index: number) => (
                    <SelectItem
                        key={cat.key}
                        catId={parseInt(cat.key)}
                        text={cat.text}
                        icon={cat.icon}
                        selectedArray={values.category || []}
                        isEditable={false}
                        editShow={addCategoryShow}
                        index={index}
                        onSelected={onCategorySelect}
                    />
                ))}
                <SelectItem
                    catId={-1}
                    text={t('addCategory')}
                    icon="add"
                    selectedArray={[]}
                    isEditable={false}
                    editShow={addCategoryShow}
                    index={-1}
                    onSelected={() => addCategoryShow.open()}
                />
            </css.categoriesWrapper>
            {addCategoryShow.isOpen && (
                <css.addCategoryPopupWrapper>
                    <MobilePopup 
                        showClass={addCategoryShow.showClass} 
                        close={addCategoryShow.close} 
                        title={t('addCategory')}
                        dataCyName="addCategory"
                        height="240px"
                        list={undefined}
                        forwardRef={undefined}
                        cssStyle="min-height: 240px; height: 240px; max-height: 240px;"
                        TopComponent={null}
                    >
                        <AddCategory 
                            close={addCategoryShow.close} 
                            onCategoryAdded={onCategorySelect}
                        />
                    </MobilePopup>
                </css.addCategoryPopupWrapper>
            )}
        </css.categorySection>
    );
}

export default CategorySelector;

